module.exports = require("@carvana/icons/CheckCircle");